/**
 * Copyright (c) 2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { __extends } from "tslib";
import { OrderedSet } from '../../../../../mol-data/int';
import { BestDatabaseSequenceMapping as BestDatabaseSequenceMappingProp } from '../../../../../mol-model-props/sequence/best-database-mapping';
import { BestDatabaseSequenceMappingColorThemeProvider } from '../../../../../mol-model-props/sequence/themes/best-database-mapping';
import { StructureElement } from '../../../../../mol-model/structure';
import { ParamDefinition as PD } from '../../../../../mol-util/param-definition';
import { PluginBehavior } from '../../../behavior';
export var BestDatabaseSequenceMapping = PluginBehavior.create({
  name: 'best-sequence-database-mapping-prop',
  category: 'custom-props',
  display: {
    name: 'Best Database Sequence Mapping'
  },
  ctor:
  /** @class */
  function (_super) {
    __extends(class_1, _super);

    function class_1() {
      var _this = _super !== null && _super.apply(this, arguments) || this;

      _this.provider = BestDatabaseSequenceMappingProp.Provider;
      _this.labelProvider = {
        label: function (loci) {
          if (!_this.params.showTooltip) return;
          return bestDatabaseSequenceMappingLabel(loci);
        }
      };
      return _this;
    }

    class_1.prototype.update = function (p) {
      var updated = this.params.autoAttach !== p.autoAttach || this.params.showTooltip !== p.showTooltip;
      this.params.autoAttach = p.autoAttach;
      this.params.showTooltip = p.showTooltip;
      this.ctx.customStructureProperties.setDefaultAutoAttach(this.provider.descriptor.name, this.params.autoAttach);
      return updated;
    };

    class_1.prototype.register = function () {
      this.ctx.customModelProperties.register(this.provider, this.params.autoAttach);
      this.ctx.representation.structure.themes.colorThemeRegistry.add(BestDatabaseSequenceMappingColorThemeProvider);
      this.ctx.managers.lociLabels.addProvider(this.labelProvider);
    };

    class_1.prototype.unregister = function () {
      this.ctx.customModelProperties.unregister(this.provider.descriptor.name);
      this.ctx.representation.structure.themes.colorThemeRegistry.remove(BestDatabaseSequenceMappingColorThemeProvider);
      this.ctx.managers.lociLabels.removeProvider(this.labelProvider);
    };

    return class_1;
  }(PluginBehavior.Handler),
  params: function () {
    return {
      autoAttach: PD.Boolean(true),
      showTooltip: PD.Boolean(true)
    };
  }
}); //

function bestDatabaseSequenceMappingLabel(loci) {
  if (loci.kind === 'element-loci') {
    if (loci.elements.length === 0) return;
    var e = loci.elements[0];
    var u = e.unit;
    var se = StructureElement.Location.create(loci.structure, u, u.elements[OrderedSet.getAt(e.indices, 0)]);
    return BestDatabaseSequenceMappingProp.getLabel(se);
  }
}